module.exports = __webpack_public_path__ + "static/media/19ESCAP17.e4c2ed71.jpg";